import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export function ProductCard({ product }) {
    const { add } = useCart();
    const { user } = useAuth();
    const pct = user && user.membership_status === "active" ? (user.discount_percent || 0) : 0;
    const memberPrice = pct ? product.price * (1 - pct / 100) : null;
    return (
        <div data-testid={`product-card-${product.id}`} className="group">
            <Link to={`/shop/${product.id}`} className="block relative overflow-hidden rounded-2xl bg-surface border border-gold/10 aspect-[4/5]">
                <img src={product.image} alt={product.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
                {product.type === "digital" && (
                    <span className="absolute top-3 left-3 text-[10px] uppercase tracking-widest bg-ink/70 text-gold px-2.5 py-1 rounded-full border border-gold/20">Digital</span>
                )}
            </Link>
            <div className="pt-4 flex items-start justify-between gap-3">
                <div>
                    <div className="text-[10px] uppercase tracking-widest text-faded mb-1">{product.category}</div>
                    <Link to={`/shop/${product.id}`}><h3 className="font-serif text-xl text-cream leading-tight hover:text-gold transition-colors">{product.name}</h3></Link>
                    <p className="mt-1">
                        {memberPrice ? (
                            <span className="inline-flex items-baseline gap-2">
                                <span className="text-gold">${memberPrice.toFixed(2)}</span>
                                <span className="text-faded line-through text-sm">${product.price.toFixed(2)}</span>
                            </span>
                        ) : (
                            <span className="text-gold">${product.price.toFixed(2)}</span>
                        )}
                    </p>
                </div>
            </div>
            <button data-testid={`add-to-cart-${product.id}`}
                onClick={() => { add(product); toast.success(`${product.name} added to basket`); }}
                className="mt-3 w-full text-sm border border-gold/30 text-gold rounded-full py-2.5 hover:bg-gold hover:text-ink transition-colors active:scale-95">
                Add to Basket
            </button>
        </div>
    );
}
